export default __webpack_public_path__ + "static/media/DSC03735.2af3ae5c.jpg";